import { TextLockupComponent as TextLockup } from '@vaad1st/component.molecule.text-lockup';
import classnames from 'classnames';
import React from 'react';
import HTMLRenderer from 'src/components/html-renderer/html-renderer.component';
import { asBoolean } from 'src/utils/boolean-conversion';
import { normalizeButtons } from 'src/utils/component-utils/normalize-buttons';
import styles from './text-lockup.component.module.less';

const containsHTML = (str: string) => /<\/?[a-z][\s\S]*>/i.test(str);

export default function TextLockupComponent(props: any) {
  const propsCopy = { ...props };

  Object.keys(propsCopy).forEach(key => {
    if (typeof propsCopy[key] === 'string')
      propsCopy[key] = propsCopy[key]
        .replaceAll('&nbsp;', '')
        .replaceAll('\r', '')
        .replaceAll('\n', '')
        .trimRight();
  });

  if (props.hasOwnProperty('children') && containsHTML(props.children)) {
    if (typeof props.children === 'string') {
      propsCopy.children = props.children ?? '';
    }
    propsCopy.children = HTMLRenderer({ htmlString: propsCopy.children });
  }

  if (propsCopy.buttons && propsCopy.buttons.length > 0) {
    propsCopy.buttons = normalizeButtons(propsCopy.buttons);
  }

  // Accordion content should not have padding
  if (props.hasOwnProperty('noPadding') && props.noPadding) {
    return <TextLockup {...propsCopy} />;
  }

  // Remove authored text lockup spacing, if specified.
  const removeBottomPadding = asBoolean(props.removeSpaceBelow);
  const removeTopPadding = asBoolean(props.removeSpaceAbove);

  return (
    <div
      className={classnames(styles['text-lockup'], {
        [styles['pb-none']]: removeBottomPadding,
        [styles['pt-none']]: removeTopPadding,
      })}>
      <TextLockup {...propsCopy} />
    </div>
  );
}
